<spb-applications
  (resultValue)="setApplication($event)"
  [initial]="{}"
></spb-applications>
